module.exports = __webpack_public_path__ + "img/household.fd6b7e75.png";